var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative",on:{"click":_vm.selectImage}},[_c('van-image',{attrs:{"src":_vm.userAvatar,"round":"","width":_vm.size,"height":_vm.size,"fit":"cover"}}),(_vm.showIcon)?_c('van-image',{staticClass:"absolute bottom-2 right-2",attrs:{"src":require('@/assets/icons/v2/icon_change_avatar.svg'),"width":"24","height":"24"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }